import { Component, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { ComponentBase, Changeable } from "common";
import { ViewerDeviceGroupDto } from "UvExplorerServer.Dtos.TS/Viewer";
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { DeviceGroupComponent } from '../device-group/device-group.component';


@Component({
    selector: 'device-group-editor',
	templateUrl: './device-group-editor.component.html'
})
export class DeviceGroupEditorComponent extends ComponentBase implements Changeable {

	@Input()
	public target: ViewerDeviceGroupDto;

	@Input()
	public network: NetViewDto;

	@Output()
	public onApply: EventEmitter<any>;

    @ViewChild(DeviceGroupComponent, { static: true })
	public deviceGroup: DeviceGroupComponent;

	public get enableApply(): boolean {
		return this.deviceGroup.enableApply;
	}

	constructor() {
		super();

		this.target = null;
		this.network = null;
		this.onApply = new EventEmitter<any>();
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["target"]) {
		}

	}

	public get tempChanges(): boolean {
		return this.deviceGroup.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.deviceGroup.tempChangesValid;
	}

	public discardTempChanges(): void {
		this.deviceGroup.discardTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.deviceGroup.invalidTempChanges;
	}

	public applyTempChanges(): void {
		if (this.target) {
			this.deviceGroup.applyTempChanges();
			this.onApply.emit();
		}
	}

}
